/**
 * This file contains authentication parameters. Contents of this file
 * is roughly the same across other MSAL.js libraries. These parameters
 * are used to initialize Angular and MSAL Angular configurations in
 * in app.module.ts file.
 */

import {
  LogLevel,
  Configuration,
  BrowserCacheLocation,
} from "@azure/msal-browser";
import { AppConstants } from "./constants/constants";

const isIEorFireFox =
  window.navigator.userAgent.indexOf("MSIE ") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1 ||
  window.navigator.userAgent.toLowerCase().indexOf("firefox") > -1;

const baseURL: string = `${window.location.protocol}${AppConstants.DOUBLE_SLASH}${window.location.hostname}`;
const siteLanguageCode: string = window.location.pathname.split(AppConstants.SLASH)[1];

const defaultRedirectURI: string = (window.location.host.indexOf(AppConstants.LOCALHOST) !== -1) ?  
  AppConstants.MSAL_SIGNED_IN_PAGE : 
  `${baseURL}${AppConstants.SLASH}${AppConstants.DEFAULT_LANG_CODE}${AppConstants.MSAL_SIGNED_IN_PAGE}`

  const logoutRedirectURI: string = (window.location.host.indexOf(AppConstants.LOCALHOST) !== -1) ?  
  AppConstants.WELCOME_PAGE : 
  `${baseURL}${AppConstants.SLASH}${AppConstants.DEFAULT_LANG_CODE}${AppConstants.WELCOME_PAGE}`

export const b2cPolicies = {
  names: {
    signIn: 'B2C_1A_usernameOrEmail_SI_MFA',
    editProfile: 'b2c_1_profileedit',
    multitenant: 'B2C_1A_multitenant_SI',
    changePassword: 'B2C_1A_PROFILEEDIT_PASSWORDCHANGE',
    forgotPassword: 'B2C_1A_SIGNIN_FORGOTPASSWORD'
  }
  // Moved to app.config.json
};

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: AppConstants.BLANK, // This is the ONLY mandatory field that you need to supply. Moved to app.config.json
    authority: AppConstants.BLANK, // Defaults to "https://login.microsoftonline.com/common" Moved to app.config.json
    knownAuthorities: [], // Mark your B2C tenant's domain as trusted. Moved to app.config.json
    redirectUri: defaultRedirectURI, // Points to window.location.origin. You must register this URI on Azure portal/App Registration. Moved to app.config.json
    navigateToLoginRequestUrl: false,
    postLogoutRedirectUri: logoutRedirectURI,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: isIEorFireFox, // Set this to "true" if you are having issues on IE11 or Edge or Firefox
  },
  system: {
    loggerOptions: {
      loggerCallback(logLevel: LogLevel, message: string) {
        console.log(message);
      },
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: false,
    },
  },
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */

// Moved to app.config.json under protectedResources

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequestEnglish = {
  scopes: [],
  extraQueryParameters: { ui_locales: AppConstants.DEFAULT_LANG_CODE }
};
export const loginRequestWelsh = {
  scopes: [],
  extraQueryParameters: { ui_locales: AppConstants.WELSH_GB_LANG_CODE }
};
export const loginRequest = {
  scopes: []
};
